// Texts of the local SERP checker form. The country value is sent to Google
// as the `gl` parameter of the result links (it is not sent to the backend).
// The first country of each list is the default one.
const content = {
  fr: {
    searchTermLabel: "Terme de recherche",
    searchTermPlaceholder: "ex: restaurant italien",
    locationLabel: "Localisation",
    locationPlaceholder: "ex: 75012 ou Paris",
    countryLabel: "Pays",
    countries: [
      { value: "fr", label: "France 🇫🇷" },
      { value: "be", label: "Belgique 🇧🇪" },
      { value: "ch", label: "Suisse 🇨🇭" },
    ],
    searchTypeLabel: "Type de recherche",
    captchaWarning: "Veuillez remplir le captcha pour accéder aux résultats.",
    loading: "Chargement...",
    submit: "Voir les résultats →",
  },
  en: {
    searchTermLabel: "Search term",
    searchTermPlaceholder: "e.g. italian restaurant",
    locationLabel: "Location",
    locationPlaceholder: "e.g. Austin, TX or 78701",
    countryLabel: "Country",
    countries: [
      { value: "us", label: "United States 🇺🇸" },
      { value: "ca", label: "Canada 🇨🇦" },
      { value: "uk", label: "United Kingdom 🇬🇧" },
      { value: "au", label: "Australia 🇦🇺" },
    ],
    searchTypeLabel: "Search type",
    captchaWarning: "Please complete the captcha to see the results.",
    loading: "Loading...",
    submit: "See results →",
  },
};

export default content;
